"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.exportToCsv = exports.downloadCSV = exports.createCSVData = void 0;
const helpers_1 = require("../helpers");
function createCSVData(columns, dataItems) {
    const csvContent = [];
    // Generate CSV header row
    const headerRow = columns.map(header => header.label);
    csvContent.push(headerRow.join(','));
    // Generate CSV data rows
    dataItems.forEach(dataItem => {
        const rowData = columns.map(header => (0, helpers_1.getAtPath)(dataItem, header.dataPath));
        csvContent.push(rowData.map(item => typeof item === "string" && item.indexOf(',') >= 0 ? `"${item}"` : String(item)).join(','));
    });
    // Join CSV rows with line breaks
    return csvContent.join('\n');
}
exports.createCSVData = createCSVData;
function downloadCSV(csvData, fileName) {
    // Create a download link and trigger the download
    const link = document.createElement('a');
    link.href = 'data:text/csv;charset=utf-8,' + encodeURIComponent(csvData);
    link.download = fileName + '.csv';
    link.click();
}
exports.downloadCSV = downloadCSV;
function exportToCsv(columns, dataItems, fileName) {
    downloadCSV(createCSVData(columns, dataItems), fileName);
}
exports.exportToCsv = exportToCsv;
